import React, { useEffect, useRef } from 'react';

const MusicPlayer = ({ currentSong, isMuted }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current && currentSong) {
      audioRef.current.src = currentSong.audio;
      audioRef.current.volume = isMuted ? 0 : 0.05;
      audioRef.current.load();
      audioRef.current.play().catch(err => console.error("Playback error:", err));
    }
  }, [currentSong, isMuted]);

  return (
    <audio ref={audioRef} autoPlay />
  );
};

export default MusicPlayer;